import { Images } from 'lucide-react';
import { Dialog, DialogContent, DialogTrigger, DialogTitle } from '@/components/ui/dialog';
import { Carousel, CarouselContent, CarouselItem, CarouselPrevious, CarouselNext } from '@/components/ui/carousel';

// A "View photos" trigger that opens a lightbox with a swipeable image carousel.
export function FleetGallery({ images, name, label = 'View photos', testid, triggerClass = '' }) {
  if (!images || images.length === 0) return null;
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button type="button" data-testid={testid} onClick={(e) => e.stopPropagation()} aria-label={`View photos of ${name || 'vehicle'}`}
          className={`inline-flex items-center gap-1.5 font-heading font-bold text-[11px] transition-colors ${triggerClass}`}>
          <Images className="w-3.5 h-3.5" /> {label}
        </button>
      </DialogTrigger>
      <DialogContent className="max-w-3xl bg-white p-4 sm:p-6" onClick={(e) => e.stopPropagation()}>
        <DialogTitle className="font-heading font-bold text-lg text-[#121212]">{name || 'Vehicle gallery'}</DialogTitle>
        <Carousel className="mt-4">
          <CarouselContent>
            {images.map((src, i) => (
              <CarouselItem key={src || i}>
                <div className="aspect-video overflow-hidden rounded-xl bg-[#F5F5F3]">
                  <img src={src} alt={`${name || 'Vehicle'} photo ${i + 1}`} className="w-full h-full object-cover" loading="lazy" />
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          {images.length > 1 && (<><CarouselPrevious className="left-2" /><CarouselNext className="right-2" /></>)}
        </Carousel>
        <p className="mt-3 text-center font-body text-xs text-[#888]">{images.length} photo{images.length > 1 ? 's' : ''}</p>
      </DialogContent>
    </Dialog>
  );
}
